import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { stroke: "currentColor" }, [
      _createElementVNode("path", { d: "m6.987 17.684-.015.019-.013.02-.011.014-.006.003a.2.2 0 0 1-.062.01.2.2 0 0 1-.039-.017.5.5 0 0 1-.098-.072l-4.66-5.655A7.7 7.7 0 0 1 .625 7.5c0-3.47 2.836-6.25 6.25-6.25 3.417 0 6.25 2.782 6.25 6.188a7.7 7.7 0 0 1-1.459 4.507zm4.463-5.868.01-.011.008-.012c.87-1.205 1.407-2.744 1.407-4.293 0-3.339-2.661-6-6-6-3.342 0-6 2.728-6 6 0 1.55.538 3.085 1.4 4.345l.013.019.014.017 4.188 5.063.387.468.385-.47z" }),
      _createElementVNode("path", { d: "M4.875 7.625c0-1.099.901-2 2-2s2 .901 2 2-.901 2-2 2-2-.901-2-2Zm.25 0c0 .964.786 1.75 1.75 1.75s1.75-.786 1.75-1.75-.786-1.75-1.75-1.75-1.75.786-1.75 1.75Z" })
    ], -1)
  ]))]))
}
export default { render: render }